import LegalPageLayout, { LegalSection } from "./LegalPageLayout";

const CONTACT_EMAIL = "ai.insightpulse@gmail.com";

export default function TermsConditions({ onClose }) {
  return (
    <LegalPageLayout
      title="Terms & Conditions"
      subtitle="Please read before using InsightPulse AI"
      updatedLabel="Last updated: July 2026"
      onClose={onClose}
    >

      <LegalSection title="1. Acceptance of Terms">
        <p>
          By accessing or using InsightPulse AI (the "Service"), you agree to be bound by these
          Terms & Conditions. If you do not agree, please do not use the Service.
        </p>
      </LegalSection>

      <LegalSection title="2. The Service">
        <p>
          InsightPulse AI lets you upload spreadsheet data (CSV/Excel), automatically generates
          dashboards and insights, and lets you ask questions about your data in a conversational
          interface. Certain features and usage limits vary by plan (Free or Premium), as
          described on the Subscription page.
        </p>
      </LegalSection>

      <LegalSection title="3. Accounts">
        <p>
          You must sign in with a valid Google account to use the Service. You are responsible
          for maintaining the confidentiality of your account and for all activity that occurs
          under it.
        </p>
      </LegalSection>

      <LegalSection title="4. Subscriptions & Billing">
        <ul className="list-disc list-inside space-y-1.5 pl-1">
          <li>The Free plan is available at no cost, subject to the usage limits shown on the Subscription page.</li>
          <li>The Premium plan is billed at $10/month and includes higher usage limits and unbranded exports, as described on the Subscription page.</li>
          <li>You may cancel or downgrade your subscription at any time from the Subscription page; changes take effect as shown in-app.</li>
          <li>Plan limits, features, and pricing may change; we will make reasonable efforts to communicate material changes.</li>
        </ul>
      </LegalSection>

      <LegalSection title="5. Your Data & Content">
        <p>
          You retain ownership of the datasets you upload and the content you create using the
          Service. You are responsible for ensuring you have the right to upload and analyze any
          data you provide, and that it does not violate any law or third-party right.
        </p>
      </LegalSection>

      <LegalSection title="6. AI-Generated Content Disclaimer">
        <p>
          Insights, answers, charts, and reports generated by InsightPulse AI are produced with
          the assistance of AI and automated calculations. While we design the system to
          calculate metrics directly from your data rather than let the AI invent numbers,
          AI-generated commentary and narrative text may still contain errors. You should
          independently verify any results before relying on them for financial, business, or
          other important decisions.
        </p>
      </LegalSection>

      <LegalSection title="7. Acceptable Use">
        <p>You agree not to:</p>
        <ul className="list-disc list-inside space-y-1.5 pl-1">
          <li>Use the Service for any unlawful purpose or in violation of any applicable regulation.</li>
          <li>Upload data you do not have the right to use or share.</li>
          <li>Attempt to disrupt, reverse-engineer, or gain unauthorized access to the Service.</li>
          <li>Use the Service to generate content that is harmful, infringing, or abusive.</li>
        </ul>
      </LegalSection>

      <LegalSection title="8. Intellectual Property">
        <p>
          The InsightPulse AI name, logo, and product design are the property of InsightPulse
          AI. These Terms do not grant you any rights to our trademarks or branding outside of
          normal use of the Service.
        </p>
      </LegalSection>

      <LegalSection title="9. Termination">
        <p>
          We may suspend or terminate access to the Service for any account that violates these
          Terms. You may stop using the Service and delete your datasets at any time.
        </p>
      </LegalSection>

      <LegalSection title="10. Disclaimer & Limitation of Liability">
        <p>
          The Service is provided "as is" without warranties of any kind. To the fullest extent
          permitted by law, InsightPulse AI shall not be liable for any indirect, incidental, or
          consequential damages arising from your use of the Service, including decisions made
          based on generated insights, reports, or analyses.
        </p>
      </LegalSection>

      <LegalSection title="11. Changes to These Terms">
        <p>
          We may update these Terms from time to time. Continued use of the Service after an
          update constitutes acceptance of the revised Terms.
        </p>
      </LegalSection>

      <LegalSection title="12. Contact Us">
        <p>
          Questions about these Terms can be sent to{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-blue-400 hover:text-blue-300 underline">
            {CONTACT_EMAIL}
          </a>.
        </p>
      </LegalSection>

    </LegalPageLayout>
  );
}
